import { Component, OnInit, Input } from "@angular/core";
import { GeocodingModel } from "src/app/models/location.model";
import { ExternalService } from "src/app/services/external/external.service";
import { SaleService } from "src/app/services/sale/sale.service";

@Component({
  selector: "delivery-info",
  templateUrl: "./delivery-info.component.html",
  styleUrls: ["./delivery-info.component.scss"]
})
export class DeliveryInfoComponent implements OnInit {
  @Input()
  deliveryType:string;

  @Input()
  geocoding:GeocodingModel = {};

  @Input()
  title:string;

  @Input()
  deliveryCost:number;

  @Input()
  currency:number;

  constructor(public externalService:ExternalService, public saleService:SaleService) {
  }

  ngOnInit(): void {
    //
  }
}
